export default {
    generateDraft: 'Générer un brouillon avec IA',
    generatingDraft: 'Réflexion',
    stopGeneration: 'Arrêter la génération',
    serviceLeadUnavailable:
        'La génération de brouillon est disponible seulement pour les leads de vente.',
    disclaimer:
        'Vous êtes responsable de votre contenu et devez vérifier tout contenu généré avant de l’utiliser.',
    error: "Une erreur est survenue lors de la génération de cette réponse. Si le problème persiste, veuillez communiquer avec notre centre d'aide à",
    rateLimit:
        "Limite d'utilisation de l'IA atteinte. Veuillez attendre {seconds} secondes avant de réessayer.",
    unsupportedUpdate:
        'L’IA n’a pas pu exécuter toute la demande, car elle n’est pas prise en charge. Veuillez vérifier le contenu avant de l’envoyer.',
    unsupportedDismiss: 'Fermer l’avis de demande non prise en charge',
    undoTooltip: 'L’annulation rétablit uniquement le brouillon généré par l’IA',
    feedbackQuestion: 'Brouillon utile ?',
    feedbackThumbsUp: 'Brouillon utile',
    feedbackThumbsDown: 'Pas utile',
    feedbackTitle: 'Qu’est-ce qui n’a pas bien fonctionné ?',
    feedbackReasons: {
        inaccurateContent: 'Contenu inexact',
        wrongTone: 'Ton incorrect',
        requiredTooMuchEditing: 'A nécessité trop de modifications',
        tooSlow: 'Trop lent',
        other: 'Autre',
    },
    feedbackDetailsPlaceholder: 'Y a-t-il quelque chose de précis à améliorer ?',
    feedbackSubmit: 'Envoyer le commentaire',
};
